import React, { useEffect, useState } from "react";
import { api } from "../lib/constants";
import { Reveal } from "../components/Reveal";
import { Overline, SectionTitle, GoldButton } from "../components/site/Primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import SEO from "../components/SEO";

export default function Duvidas() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title="Dúvidas Frequentes sobre Prótese Capilar | Prime Capilar Clinic" description="Perguntas frequentes sobre prótese capilar: aplicação, durabilidade, manutenção, cuidados e onde fazer." />

      <section className="border-b border-white/10 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal><Overline className="mb-3">Perguntas frequentes</Overline></Reveal>
          <Reveal delay={0.05}><SectionTitle>Tire suas dúvidas</SectionTitle></Reveal>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-b border-white/10">
              <AccordionTrigger className="text-left font-heading font-500 text-white text-base hover:text-gold hover:no-underline py-5">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed text-sm pb-5">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center">
          <GoldButton to="/protese-capilar" size="lg" data-testid="duvidas-cta">QUERO FAZER UMA AVALIAÇÃO</GoldButton>
        </div>
      </section>
    </div>
  );
}
